import React from 'react'
import {Input} from 'antd'
import './style.css'

export const CustomInput = (props) => {
	const { className, ...otherProps } = props
	let type = props.type
	let node = undefined
	switch(type) {
		case 'password':
			node = <Input.Password
				{ ...otherProps }
				className={ `custom-input ${ className }`}
			/>
			break
		default:
			node = <Input
				{ ...otherProps }
				className={ `custom-input ${ className }`}
			/>
	}
	return node
}
